import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { useDirection } from '../../hooks';
import { InputContainer } from '../InputContainer';
import StyledInput from './StyledInput';
import { InputProps } from './types';

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      focus,
      invalid,
      disabled,
      onFocus,
      onBlur,
      onClick,
      onChange,
      id,
      type,
      value,
      placeholder,
      sx,
      ...rest
    },
    ref
  ) => {
    const isRtl = useDirection();
    return (
      <InputContainer
        onFocus={onFocus}
        onBlur={onBlur}
        onClick={onClick}
        disabled={disabled}
        invalid={invalid}
        focus={focus}
      >
        {label}
        <StyledInput
          id={id}
          type={type}
          value={value}
          placeholder={placeholder}
          focus={focus}
          invalid={invalid}
          aria-invalid={invalid}
          disabled={disabled}
          isRtl={isRtl}
          sx={sx}
          {...rest}
          onChange={onChange}
          ref={ref}
        />
      </InputContainer>
    );
  }
);

Input.propTypes = {
  focus: PropTypes.bool,
  invalid: PropTypes.bool,
  disabled: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'button',
    'checkbox',
    'color',
    'date',
    'datetime-local',
    'email',
    'file',
    'hidden',
    'image',
    'month',
    'number',
    'radio',
    'range',
    'reset',
    'search',
    'submit',
    'time',
    'url',
    'week',
    'text',
    'tel',
    'password',
  ]),
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

export default Input;
